import React from 'react';
import { Button, Container, Nav, Navbar, NavLink } from 'react-bootstrap';
import './Header.css';

const Header = () => {
    return (
        <div className="navigation-bar sticky-middle" >
            <Navbar collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand className="ms-0" href="#banner" style={{ color: "#64FFDA" }}>Aulad Hossen</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                        </Nav>
                        <Nav className="my-4 mx-5 px-5 mr-0">
                            <NavLink href="#about" style={{ color: "#B0BCDA" }}>About</NavLink>
                            <NavLink href="#projects" style={{ color: "#B0BCDA" }}>Projects</NavLink>
                            <NavLink href="#blogs" style={{ color: "#B0BCDA" }}>Blogs</NavLink>
                            <NavLink href="#contact" style={{ color: "#B0BCDA" }}>Contact</NavLink>
                            <a className="custom-button" target="_blank" style={{ marginTop: "0px", textDecoration: "none" }} href="https://drive.google.com/file/d/1sfCYWXZSmGkmwQNVZ56bq6AoB5v7PNqs/view?usp=sharing" download>Resume</a>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div >
    );
};

export default Header;